import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { ArrowRight, LockKeyhole } from "lucide-react";
import "./admin.css";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function apiError(error) {
  const detail = error?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((item) => item?.msg).filter(Boolean).join(" ");
  return "Unable to sign in. Please try again.";
}

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (event) => {
    event.preventDefault();
    setBusy(true); setError("");
    try {
      await axios.post(`${API}/auth/login`, { email, password }, { withCredentials: true });
      navigate("/admin/waitlist", { replace: true });
    } catch (requestError) { setError(apiError(requestError)); } finally { setBusy(false); }
  };
  return <main className="admin-shell" data-testid="admin-login-page">
    <section className="admin-login-panel fade-up" data-testid="admin-login-panel">
      <div className="admin-mark" data-testid="admin-login-mark"><LockKeyhole size={18} /> private access</div>
      <p className="wordmark admin-wordmark" data-testid="admin-login-wordmark">marova</p>
      <h1 className="serif" data-testid="admin-login-heading">Your waitlist, in one place.</h1>
      <p className="admin-muted" data-testid="admin-login-description">Sign in to view and export your early community.</p>
      <form onSubmit={submit} className="admin-form" data-testid="admin-login-form">
        <label htmlFor="admin-email" data-testid="admin-email-label">Email</label>
        <input id="admin-email" data-testid="admin-email-input" type="email" autoComplete="email" value={email} onChange={(event) => setEmail(event.target.value)} required />
        <label htmlFor="admin-password" data-testid="admin-password-label">Password</label>
        <input id="admin-password" data-testid="admin-password-input" type="password" autoComplete="current-password" value={password} onChange={(event) => setPassword(event.target.value)} required />
        {error && <div className="admin-error" role="alert" data-testid="admin-login-error">{error}</div>}
        <button className="admin-button" data-testid="admin-login-submit" type="submit" disabled={busy}>{busy ? "Signing in…" : <>Open waitlist <ArrowRight size={16} /></>}</button>
      </form>
    </section>
  </main>;
}